import React, { Component } from 'react';
import { iconExlcusiveCallBackState } from '../../../Images/AgentStatusSVG';
import { Singleton } from '../../../js/Singleton';
import { SingletonSharedData } from '../../../js/singletonSharedData';

export default class ExclusiveCallBack extends Component{
  constructor(props){
    super(props);
    this.sharedData = new SingletonSharedData();
    this.language = new Singleton();
  }
  render() {
    return (
      <div className="exclusiveCallBackContainer">
        <div className="exclusiveCallBackTop">
          <div className="circle1"></div>
          <div className="circle2"></div>
          <div className="exclusiveCallBackAnimation"> {iconExlcusiveCallBackState}</div>
        </div>
        <p className="titleExclsiveCallBack">{this.language.getText('GUIAgentStateexclusiveCallBack')}</p>
        <p className="textExclusiveCallBack">{this.sharedData.getPhoneCallBack()}</p>
        <p className="textExclusiveCallBack">{this.language.getText('GUIAgentStateconnectingCall')}</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/workSpace/Others/ExclusiveCallBack.jsx